<template lang="pug" >
form.form-body-follow
  template(v-for="item in private_community_all")
    CommunityItem(:o="item")
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import CommunityItem from './CommunityItem.vue'
export default {
  components: {
    CommunityItem
  },
  data() {
    return {
      private_community_all: []
    }
  },
  methods: {
    async getAllPCForUser() {
      var variables = {
        where: {
          is_public: {_eq: 2},
          status: {_eq: 1}
        },
        orderBy: {
          pc_users_aggregate: {count: 'desc'}
        },
        limit: 10
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_PRIVATE_COMMUNITY_USER_ALL),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.private_community_all = data.private_community
      }
    }
  },
  async created () {
    await this.getAllPCForUser()
  },
  apollo: {
  }
}
</script>

<style lang='scss'>
  // .box-item-com-mo{border-bottom: 1px solid #FAFAFA; padding-bottom: 15px; margin-bottom:15px;
  //   &:last-child{margin-bottom: 0; padding: 0; border:0 none;}
  //   .item-img-com-mo{margin: 0 auto; padding: 0 !important;
  //     img{max-width: 100%; height: auto;}
  //   }
  //   .item-info-com-mo{padding: 0 10px !important;
  //     .child-item-info{margin-bottom:15px;
  //       .icon_com_mo{width: 16px; height: 16px; float:left;
  //         img{border-radius: 50%;overflow:hidden;}
  //       }
  //       .text_com_mo{width: calc(100% - 30px);float:left; margin-left: 10px;}
  //     }
  //   }
  // }
  .big_icon_com_mo{
    .img-format{width: 40px; margin: 0 auto; border-radius: 50%; overflow: hidden;
      img{max-width: 100% !important;  width: auto !important; border-radius: 0 !important;height: 40px; }
    }
  }
  .icon_com_mo {
    .icon-div{width: 16px;margin: 0 auto; border-radius: 50%; overflow: hidden;
      img{height: 16px; max-width: 100%;}
    }
  }
  
@media only screen 
    and (min-device-width : 375px) 
    and (max-device-width : 812px)  { 
    .icon_com_mo {
        padding:0;
        margin-left: 5px;
    }
    .big_icon_com_mo {
        padding: 2px;
    }
    .text_com_mo {
        margin-left:-15px;
        font-size: 11px;
    }
    .row_com_mo {
        margin-top:5px;
    }
}
.img_com {
        border-radius: 50%;
    }
</style>



// WEBPACK FOOTER //
// Community.vue?de7f7cbe